import { render } from "./GridDrepturiUtilizatori.vue?vue&type=template&id=6f635c3e&scoped=true&ts=true"
import script from "./GridDrepturiUtilizatori.vue?vue&type=script&lang=ts"
export * from "./GridDrepturiUtilizatori.vue?vue&type=script&lang=ts"

import "./GridDrepturiUtilizatori.vue?vue&type=style&index=0&id=6f635c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f635c3e"]])

export default __exports__